import { DocumentRequestStatusEnum } from '../enums/document-request-status.enum';

export const DocumentRequestStatusLabel = {
  [DocumentRequestStatusEnum.REQUESTED]: 'Requested',
  [DocumentRequestStatusEnum.PARTIALLY_UPLOADED]: 'Partially Uploaded',
  [DocumentRequestStatusEnum.READY_FOR_REVIEW]: 'Ready for review',
  [DocumentRequestStatusEnum.APPROVED]: 'Approved',
  [DocumentRequestStatusEnum.ATTENTION]: 'Document needs attention',
  [DocumentRequestStatusEnum.UPLOADED]: 'Submitted',
  [DocumentRequestStatusEnum.NEEDS_REVIEW]: 'Needs Review',
  [DocumentRequestStatusEnum.DEFAULT]: '',
};

export const DocumentRequestStatusForCandidateListLabel = {
  [DocumentRequestStatusEnum.REQUESTED]: 'Documents Requested',
  [DocumentRequestStatusEnum.READY_FOR_REVIEW]: 'Documents Ready for Review',
  [DocumentRequestStatusEnum.APPROVED]: 'Documents Approved',
  [DocumentRequestStatusEnum.ATTENTION]: 'Document needs attention',
  [DocumentRequestStatusEnum.UPLOADED]: 'Submitted',
  [DocumentRequestStatusEnum.NEEDS_REVIEW]: 'Needs Review',
  [DocumentRequestStatusEnum.REJECTED]: 'Document Rejected',
  [DocumentRequestStatusEnum.PARTIALLY_UPLOADED]: 'Partially Uploaded',
  [DocumentRequestStatusEnum.DEFAULT]: '',
};
